export const DEFAULT_CHAIN_ID = 900
